module.exports = __webpack_public_path__ + "img/alert.e2540ae1.png";